import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

const TOKEN_KEY = "ez_token";

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete client.defaults.headers.common["Authorization"];
  }
}

// Restore token on load
const saved = localStorage.getItem(TOKEN_KEY);
if (saved) client.defaults.headers.common["Authorization"] = `Bearer ${saved}`;

export function apiErr(e, fallback = "Something went wrong") {
  const status = e?.response?.status;
  if (status === 502 || status === 503 || status === 504) return "The request took too long or the server was busy. Please try again.";
  let d = e?.response?.data?.detail;
  if (d == null) d = e?.message;
  let msg;
  if (typeof d === "string") msg = d;
  else if (Array.isArray(d)) msg = d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  else if (d?.msg) msg = d.msg;
  else msg = d != null ? String(d) : fallback;
  // Never surface raw HTML (e.g. Cloudflare 502 pages) or huge blobs in a toast.
  if (/<html|<!doctype|cloudflare|<body|<head/i.test(msg) || msg.length > 200) {
    return "The request failed. Please try again.";
  }
  return msg || fallback;
}

export { API };
export default client;
